module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-05879644!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Footer.vue
// module id = 459
// module chunks = 2